module.exports = __webpack_public_path__ + "img/circle-arrow-left.b08a8fb6.svg";